module.exports = __webpack_public_path__ + "img/fondo-web-4.56b475f6.jpg";